export default __webpack_public_path__ + "static/media/pedigrees-iso.9516c29d.png";